import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCopyPaste';
/** Renders an SVG icon. */
const SvgCopyPaste = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M16 28a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V17.586L26.414 14H18a2 2 0 0 0-2 2zm12 0H18V16h7v2a1 1 0 0 0 1 1h2zM9 26a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2h2a1 1 0 0 1 1 1v5a1 1 0 1 0 2 0V7a3 3 0 0 0-3-3h-2a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2H9a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h5a1 1 0 1 0 0-2zm11-1a1 1 0 0 0 1 1h4a1 1 0 1 0 0-2h-4a1 1 0 0 0-1 1m0-4a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2h-3a1 1 0 0 0-1 1M13 6V4h6v2z"
      />
    </svg>
  );
};
SvgCopyPaste.displayName = displayName;
export default SvgCopyPaste;
